import $ from 'jquery';
import Util from 'root/module/util';
import Form from 'root/module/form';
import Constants from 'root/constants';
import Cache from 'root/cache';
import UI from 'root/ui';
import View from 'view/base';
import Dnd_File_Uploader from 'root/module/dnd_file_uploader';

export default View.extend({
    project_id: 0,
    user_id: -1,
    priority: 'neutral',
    feedback_type: null,
    category: [],
    screenshots: [],

    category_options: null,

    events: {
        'click .region-project li'           : 'onSelectProject',
        'click .region-feedback-type li'     : 'onSelectFeedbackType',
        'click .region-priority li'          : 'onSelectPriority',
        'click .region-assignee li'          : 'onSelectAssignee',
        'click .region-category li'          : 'onSelectCategory',
        'click .screenshot-upload'           : 'onUploadScreenshot',
        'click .image-preview-delete'        : 'onDeleteImagePreview',
        'click .session-info-toggle'         : 'onToggleSessionInfo',
        'click .browser-version'             : 'onSelectBrowser',
        'click .os-version'                  : 'onSelectOs',
        'click button.submit'                : 'onClickSubmitButton',
        'submit form'                        : 'onSubmit',
        'keyup input[name="title"]'          : 'onFormChange',
        'keyup textarea[name="description"]' : 'onFormChange',
        'click .pick-due-date'               : 'pickDueDate',
        'change input[name="feedback_due_date"]' : 'onChangeFeedbacksDueDate'
    },

    dom_handlers: {
        onSelectProject: function(e) {
            this.project_id = parseInt($(e.currentTarget).data('val'), 10);

            // update assignee for the newly selected project
            var project_users = Cache.app.getUsersByProject(this.project_id);
            var user_found = false;
            project_users.map((user) => {
                if (user.id === this.user_id) {
                    user_found = true;
                }
            });
            if (!user_found) {
                this.user_id = -1;
            }

            // update category for the newly selected project
            if (this.category_options) {
                this.category.forEach((category_name) => {
                    if (this.category_options[this.project_id] && this.category_options[this.project_id].indexOf(category_name) === -1) {
                        this.category.splice(this.category.indexOf(category_name), 1);
                    }
                });
            }

            this.renderAssignee();
            this.renderCategory();
            this.checkForm();
        },

        onSelectFeedbackType: function(e) {
            this.feedback_type = parseInt($(e.currentTarget).data('val'), 10);
            this.checkForm();
        },

        onSelectPriority: function(e) {
            this.priority = $(e.currentTarget).data('val');
            this.renderPriority();
        },

        onSelectCategory: function(e) {
            var category_name = $(e.currentTarget).data('val');
            var index = this.category.indexOf(category_name);

            if (index === -1) {
                this.category.push(category_name);
            } else {
                this.category.splice(category_name, 1);
            }

            this.renderCategory();
        },

        onSelectAssignee: function(e) {
            this.user_id = parseInt($(e.currentTarget).data('val'), 10);
            this.renderAssignee();
        },

        onUploadScreenshot: function(e) {
            Util.uploadImages(10, 5, (result) => {
                result.forEach((image_data) => {
                    if (image_data.content && this.screenshots.length < 3) {
                        this.screenshots.push({
                            width: image_data.width,
                            height: image_data.height,
                            content: image_data.content
                        });
                    } else if (image_data.error) {
                        UI.error(image_data.error);
                    }
                });

                this.renderScreenshots();
            });
        },

        onDeleteImagePreview: function(e) {
            var index = $(e.currentTarget).data('val');

            this.screenshots.splice(index, 1);
            this.renderScreenshots();
        },

        onFormChange: function(e) {
            this.checkForm();
        },

        onToggleSessionInfo: function(e) {
            this.$el.find('.session-info').toggle();

            if (this.$el.find('.session-info').is(':visible')) {
                this.$el.find('input[name="email"]').focus();
            }
        },

        onSelectBrowser: function(e) {
            this.$el.find('.browser-version').removeClass('selected').css('opacity', 0.6);
            $(e.currentTarget).addClass('selected').css('opacity', '');
        },

        onSelectOs: function(e) {
            this.$el.find('.os-version').removeClass('selected').css('opacity', 0.6);;
            $(e.currentTarget).addClass('selected').css('opacity', '');
        },

        onClickSubmitButton: function(e) {
            this.$el.find('form button[type="submit"]').trigger('click');
        },
        onSubmit: function(e) {
            var form_fields = this.$el.find('input[type="text"], textarea, button.dropdown-select');

            form_fields.prop('disabled', true);
            this.$el.find('.submit').prop('disabled', true).addClass('loading', true);

            var form_data = Form.getData(this.$el.find('form'));

            var browser_version = this.$el.find('.browser-version.selected');
            var os_version      = this.$el.find('.os-version.selected');
            var user_agent      = [];

            if (os_version.length) {
                user_agent.push(os_version.data('val'));
            }

            if (browser_version.length) {
                user_agent.push(browser_version.data('val'));
            }

            Cache.app.request({
                action: 'feedback/uploadFeedback',
                context: this,
                data: {
                    email         : form_data.email,
                    name          : form_data.name,
                    page          : form_data.page,
                    title         : form_data.title,
                    description   : form_data.description,
                    user_agent    : user_agent.join(' '),
                    project_id    : this.project_id,
                    feedback_type : this.feedback_type,
                    user_id       : this.user_id,
                    priority      : this.priority,
                    category      : this.category,
                    screenshots   : this.screenshots,
                    due_date      : this.due_date
                },
                success: function(response) {
                    this.trigger('submit:success', response);
                },
                complete: function() {
                    form_fields.prop('disabled', false);
                    this.$el.find('.submit').prop('disabled', false).removeClass('loading', true);
                }
            });
        },
        pickDueDate: function(e) {
            e.preventDefault();

            var type = $(e.currentTarget).data('type');
            if (type === 'tomorrow' || type === 'next_monday') {
                this.doChangeFeedbacksDueDate(type);
            } else if (type === 'auto') {
                this.doChangeFeedbacksDueDate('auto');
            } else {
                this.$el.find('input[name="feedback_due_date"]').get(0).showPicker();
            }
        },
        onChangeFeedbacksDueDate: function(e) {
            var due_date = $(e.currentTarget).val();
            this.doChangeFeedbacksDueDate(due_date);
        }
    },

    event_handlers: {
        handleFiles: function(files) {
            this.$el.find('.dnd-dropzone').hide();
            for (var i = 0; i < files.length; i++) {
                if (files[i].type.indexOf('image/') === -1) {
                    continue;
                }

                Util.blobTodataURI(files[i], (result) => {
                    if (this.screenshots.length < 3) {
                        this.screenshots.push({
                            width   : result.width,
                            height  : result.height,
                            content : result.data_uri
                        });

                        this.renderScreenshots();
                        this.$el.find('textarea').focus();
                    }
                });
            }
        },

        handleDragEnter: function() {
            this.$el.find('.dnd-dropzone').show();
            this.$el.find('.new-comment').siblings('.new-comment-action-bar').show();
            this.$el.find('.new-comment').focus();
        },

        handleDragLeave: function(event) {
            if (event.target === this.$el.find('.dnd-dropzone').get(0)) {
                this.$el.find('.dnd-dropzone').hide();
            }
        }
    },

    initialize: function(options) {
        this.project_id    = options.project_id    || 0;
        this.user_id       = options.user_id       ||  -1,
        this.priority      = options.priority      || 'neutral';
        this.feedback_type = options.feedback_type || null;
        this.category      = options.category      || [];
        this.screenshots   = options.screenshots   || [];
        this.due_date      = options.due_date      || 'auto';

        this.uploader = new Dnd_File_Uploader(
            this.event_handlers.handleFiles.bind(this),
            this.event_handlers.handleDragEnter.bind(this),
            undefined,
            this.event_handlers.handleDragLeave.bind(this)
        );
    },

    loadCategories: function() {
        // categories
        Cache.app.request({
            action: 'feedback\\category/loadAll',
            success: (response) => {
                this.category_options = response;
                this.renderCategory();
            }
        });
    },

    focus: function() {
        this.$el.find('.dropdown-select:first').focus();
    },

    checkForm: function() {
        var has_project       = this.project_id > 0;
        var has_feedback_type = this.feedback_type !== null;
        var has_title         = this.$el.find('input[name="title"]').val().trim().length > 0;
        var has_description   = this.$el.find('textarea[name="description"]').val().trim().length > 0;

        this.$el.find('.region-category  > button').prop('disabled', this.project_id === 0);
        this.$el.find('.region-assignee  > button').prop('disabled', this.project_id === 0);

        this.$el.find('button.submit').prop('disabled', !has_project || !has_feedback_type || !has_title || !has_description);
    },

    doChangeFeedbacksDueDate: function(due_date) {
        this.due_date = due_date;

        this.renderDueDate();
    },

    renderPriority: function() {
        var option_selected = this.$el.find('.region-priority li[data-val="' + this.priority + '"]');

        this.$el.find('.region-priority > button').html('<span class="priority-status-' + this.priority + '"></span>' + Util.cap(this.priority));
        this.$el.find('.region-priority li.selected').removeClass('selected');
        option_selected.addClass('selected');
    },

    renderCategory: function() {
        var options = '';
        var option_selected = '';

        this.category.forEach((category_name) => {
            option_selected +=
            '<span class="badge-primary-invert">' +
                '<span>' + Util.htmlEntities(category_name) + '</span>' +
            '</span>';
        });

        if (!option_selected) {
            option_selected = '<span class="placeholder-text">Select...</span>';
        }

        if (this.category_options === null) {
            options += '<li class="disabled">Loading...</li>';
        } else if (this.category_options[this.project_id]) {
            this.category_options[this.project_id].forEach((category_name) => {
                var is_selected = this.category.indexOf(category_name) !== -1;
                options += '<li data-val="' + Util.htmlEntities(category_name) + '"' + (is_selected ? ' class="selected"' : '') + '>' + Util.htmlEntities(category_name) + '</li>';
            });
        }

        this.$el.find('.region-category > button').html(option_selected);
        this.$el.find('.region-category ul').html(options);
    },

    renderAssignee: function() {
        var options = '<li data-val="-1"' + (this.user_id === -1 ? ' class="selected"' : '') + '><img class="user-img" src="/image/profile.png">Automatic</li>';

        Cache.app.getUsersByProject(this.project_id, [Constants.ADMIN, Constants.ASSIGNEE]).forEach((user_model) => {
            options +=
            '<li data-val="' + user_model.id + '"' + (user_model.id === this.user_id ? ' class="selected"' : '') + '>' +
                '<img class="user-img" src="' + user_model.getAvatar() + '">' +
                user_model.escape('name') +
            '</li>';
        });

        var avatar_url = '';
        var name       = '';
        if (this.user_id === 0 || !Cache.user.get(this.user_id)) {
            avatar_url = '/image/profile.png';
            name = '<span class="placeholder-text">Automatic</span>';
        } else {
            avatar_url = Cache.user.get(this.user_id).getAvatar();
            name = Cache.user.get(this.user_id).escape('name');
        }

        this.$el.find('.region-assignee > button').html('<img class="icon-img icon-img-round" src="' + avatar_url + '">' + name);
        this.$el.find('.region-assignee ul').html(options);
    },

    renderDueDate: function() {
        var options = '';
        options +=
            '<li class="pick-due-date" data-type="auto">' +
                '<div class="flex-between">' +
                    'Automatic' +
                '</div>' +
            '</li>' +
            '<li class="pick-due-date" data-type="tomorrow">' +
                '<div class="flex-between">' +
                    '<span>Tomorrow</span>' +
                    '<span class="text-info margin-left-24">' + Util.getTomorrow('dddd') + '</span>' +
                '</div>' +
            '</li>' +
            '<li class="pick-due-date" data-type="next_monday">' +
                '<div class="flex-between">' +
                    '<span>Next week</span>' +
                    '<span class="text-info margin-left-24">' + Util.getNextMonday('dddd') + '</span>' +
                '</div>' +
            '</li>' +
            '<li class="pick-due-date">Pick a date</li>';

        this.$el.find('.due-date-list ul').html(options);

        if (this.due_date === 'tomorrow') {
            this.$el.find('.feedback-due-date-text').text(Util.getTomorrow('DD MMM YYYY'));
        } else if (this.due_date === 'next_monday') {
            this.$el.find('.feedback-due-date-text').text(Util.getNextMonday('DD MMM YYYY'));
        } else if (this.due_date === 'auto') {
            this.$el.find('.feedback-due-date-text').html('<span class="placeholder-text">Automatic</span>');
        } else {
            // format this.due_date from yyyy-mm-dd to dd MMM yyyy
            var due_date = Util.dateStringToTimestamp(this.due_date, 'YYYY-MM-DD');

            this.$el.find('.feedback-due-date-text').text(Util.moment(due_date, 'DD MMM YYYY', false, false, false));
        }
    },

    renderScreenshots: function() {
        var html = '';

        this.screenshots.forEach((screenshot_data, index) => {
            html +=
                '<div class="image-preview">' +
                    '<div style="background-image:url(\'' + screenshot_data.content + '\')"></div>' +
                    '<button type="button" class="image-preview-delete" data-val="' + index + '"><i class="fa-solid fa-times-circle"></i></button">' +
                '</div>';
        });

        this.$el.find('.new-feedback-editor-actions').find('.attachments').html(html);
        this.$el.find('.new-feedback-editor-desc').toggleClass('haspreview', this.screenshots.length > 0);

        this.$el.find('.screenshot-upload').prop('disabled', this.screenshots.length >= 3);
    },

    render: function() {
        var project_options  = '';

        Cache.project.where({is_archived: false, project_type: 'feedback'}).forEach((project_model) => {
            project_options +=
                '<li data-val="'+ project_model.id + '"' + (this.project_id === project_model.id ? ' class="selected"' : '') + '>' +
                    '<div class="flex-start">' +
                        (project_model.get('logo') ?
                        '<span class="project-logo-icon-small" style="background-image:url(' + project_model.escape('logo') + ');"></span>' :
                        '<span class="project-type-icon-small" data-val="' + (project_model.isFeedback() ? 'feedback' : 'survey') +'"></span>') +
                        '<span class="ellipsis margin-left-8">' + project_model.escape('name') + '</span>' +
                    '</div>' +
                '</li>';
        });

        var selected_project = Cache.project.get(this.project_id);

        var content =
        '<form class="form-fluid">' +
            '<div class="row">' +
                '<div class="field-label">Project</div>' +
                '<div class="button-dropdown button-dropdown-full region-project" data-update="true">' +
                    '<button type="button" class="dropdown-select dropdown-select-medium">' +
                        (selected_project ?
                        '<div class="flex-start">' +
                            (selected_project.get('logo') ?
                            '<span class="project-logo-icon-small" style="background-image:url(' + selected_project.escape('logo') + ');"></span>' :
                            '<span class="project-type-icon-small" data-val="' + (selected_project.isFeedback() ? 'feedback' : 'survey') +'"></span>') +
                            '<span class="ellipsis margin-left-8">' + selected_project.escape('name') + '</span>' +
                        '</div>' :
                        '<span class="placeholder-text">Select...</span>') +
                    '</button>' +
                    '<div>' +
                        '<ul class="dropdown' + (project_options ? ' dropdown-select' : '') + '">' +
                            (project_options || '<li class="disabled" data-val="0">No feedback projects</li>') +
                        '</ul>' +
                    '</div>' +
                '</div>' +
            '</div>' +

            '<div class="row">' +
                '<div class="field-label">Feedback type</div>' +
                '<div class="button-dropdown button-dropdown-full region-feedback-type" data-update="true">' +
                    '<button type="button" class="dropdown-select dropdown-select-medium"><span class="placeholder-text">Select...</span></button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select">' +
                            '<li data-val="' + Constants.FEEDBACK_BUG + '">Bug</li>' +
                            '<li data-val="' + Constants.FEEDBACK_FEATURE_REQUEST + '">Idea</li>' +
                            '<li data-val="' + Constants.FEEDBACK_GENERAL +  '">General</li>' +
                        '</ul>' +
                    '</div>' +
                '</div>' +
            '</div>' +

            '<div class="row">' +
                '<div class="field-label">Title</div>' +
                '<input type="text" class="solid medium" name="title" placeholder="Give it a title" required>' +
            '</div>' +

            '<div class="row position-relative">' +
                '<div class="field-label">Description</div>' +

                '<div class="new-feedback-editor-desc solid-field">' +
                    '<textarea class="compact" name="description" rows="8" placeholder="Add more details to help better understand the feedback." required></textarea>' +
                    '<div class="dnd-dropzone" data-size="medium" style="display: none"></div>' +
                '</div>' +

                '<div class="new-feedback-editor-actions">' +
                    '<div class="attachments"></div>' +
                    '<button type="button" class="screenshot-upload tooltip" data-title="Upload screenshots"><i class="fa-solid fa-images"></i></button>' +
                '</div>' +
            '</div>' +

            '<div class="row">' +
                '<div class="field-label">Priority</div>' +
                '<div class="button-dropdown button-dropdown-full region-priority">' +
                    '<button type="button" class="dropdown-select dropdown-select-medium"></button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select">' +
                            '<li data-val="urgent"><span class="priority-status-urgent"></span>Urgent</li>' +
                            '<li data-val="high"><span class="priority-status-high"></span>High</li>' +
                            '<li data-val="neutral"><span class="priority-status-neutral"></span>Neutral</li>' +
                            '<li data-val="low"><span class="priority-status-low"></span>Low</li>' +
                        '</ul>' +
                    '</div>' +
                '</div>' +
            '</div>' +

            '<div class="row">' +
                '<div class="field-label">Category</div>' +
                '<div class="button-dropdown button-dropdown-full button-dropdown-up region-category">' +
                    '<button type="button" class="dropdown-select dropdown-select-medium dropdown-select-multiple"></button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select"></ul>' +
                    '</div>' +
                '</div>' +
            '</div>' +

            '<div class="row">' +
                '<div class="field-label">Assignee</div>' +
                '<div class="button-dropdown button-dropdown-full button-dropdown-up region-assignee">' +
                    '<button type="button" class="dropdown-select dropdown-select-medium"></button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select"></ul>' +
                    '</div>' +
                '</div>' +
            '</div>' +

            // Due date
            '<div class="row">' +
                '<div class="field-label">Due date</div>' +
                '<div class="region-due-date button-dropdown button-dropdown-full" data-append="true" >' +
                    '<button type="button" class="dropdown-select dropdown-select-medium feedback-due-date-text tooltip">' +
                        '<span class="placeholder-text">Select...</span>' +
                    '</button>' +
                    '<div class="due-date-list">' +
                        '<ul class="dropdown">' +
                        '</ul>' +
                    '</div>' +
                '</div>' +
                '<input type="date" name="feedback_due_date" class="hidden-date-picker" >' +
            '</div>' +

            '<div>' +
                '<button type="button" class="session-info-toggle text-primary-small"><i class="fa-solid fa-circle-plus"></i>Session Info</button>' +
            '</div>' +

            '<div class="divider-12"></div>' +

            '<div class="session-info border-solid bg-solid padding-16" style="display:none;">' +
                '<div class="row">' +
                    '<div class="field-label margin-bottom-4">User details</div>' +
                    '<div class="text-info text-small margin-bottom-12">Fill in the email and name if you are logging the feedback on behalf of a user.</div>' +
                    '<div class="grid-6-6">' +
                        '<div class="padding-right-4"><input type="email" class="solid medium" name="email" placeholder="Email" ></div>' +
                        '<div class="padding-left-4"><input type="text" class="solid medium" name="name" placeholder="Name"></div>' +
                    '</div>' +
                '</div>' +

                '<div class="row">' +
                    '<div class="field-label margin-bottom-4">Page url</div>' +
                    '<div class="text-info text-small margin-bottom-12">Where did the issue occur?</div>' +
                    '<input type="url" class="solid medium" name="page" placeholder="https://www.example.com">' +
                '</div>' +

                '<div class="row">' +
                    '<div class="field-label">Browser</div>' +
                    '<button type="button" class="browser-version solid-white small margin-right-4" data-val="Chrome"><img class="v-align-sub" src="/image/chrome_logo.png" width="16" height="16"> Chrome</button>' +
                    '<button type="button" class="browser-version solid-white small margin-right-4" data-val="Firefox"><img class="v-align-sub" src="/image/firefox_logo.png" width="16" height="16"> Firefox</button>' +
                    '<button type="button" class="browser-version solid-white small margin-right-4" data-val="Edge"><img class="v-align-sub" src="/image/edge_logo.png" width="16" height="16"> Edge</button>' +
                    '<button type="button" class="browser-version solid-white small margin-right-4" data-val="Safari"><img class="v-align-sub" src="/image/safari_logo.png" width="16" height="16"> Safari</button>' +
                    '<button type="button" class="browser-version solid-white small margin-right-4" data-val="unknown"><i class="fa-solid fa-circle-question text-info"></i> Other</button>' +
                '</div>' +

                '<div class="row">' +
                    '<div class="field-label">Operating system</div>' +
                    '<button type="button" class="os-version solid-white small margin-right-4" data-val="Windows"><i class="fa-brands fa-windows text-windows"></i> Windows</button>' +
                    '<button type="button" class="os-version solid-white small margin-right-4" data-val="Macintosh"><i class="fa-brands fa-apple"></i> MacOS</button>' +
                    '<button type="button" class="os-version solid-white small margin-right-4" data-val="iPhone"><i class="fa-brands fa-apple"></i> iOS</button>' +
                    '<button type="button" class="os-version solid-white small margin-right-4" data-val="Android"><i class="fa-brands fa-android text-android"></i> Android</button>' +
                    '<button type="button" class="os-version solid-white small margin-right-4" data-val="unknown"><i class="fa-solid fa-circle-question text-info"></i> Other</button>' +
                '</div>' +
            '</div>' +

            '<div class="divider-24"></div>' +
            '<button type="submit"></button>' +
        '</form>' +

        '<div class="sidebar-bottom padding-12">' +
            '<button class="primary submit" disabled>Create</button>' +
        '</div>'

        this.$el.html(content);

        this.renderPriority();
        this.renderCategory();
        this.renderAssignee();
        this.renderDueDate();

        this.uploader.setupDropArea(this.$el.find('.new-feedback-editor-desc').get(0));

        this.checkForm();

        if (this.category_options === null) {
            this.loadCategories();
        }

        return this;
    }
});